import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateFormData } from "../../redux/dispatch";
import useRubriqueNav from "../../hooks/useRubriqueNav";
import RubriqueNav from "../shared/RubriqueNav";
import TabPages from "./tabs/TabPages";
import TabDernierePage from "./tabs/TabDernierePage";
import "./NouvelleHospitalisation.css";
import toast from 'react-hot-toast';
import { saveDossier } from "../../redux/dispatch";
import SaveLoader from "../shared/SaveLoader";
import { API_BASE } from "../../config/api";
import noImage from "../../assets/no-image.svg";
const RUBRIQUE = "nouvelle_hospitalisation";

const EMPTY_PAGE = () => ({
  date_debut:        "",
  date_fin:          "",
  medecin:           "",
  motif:             "",
  poids:             "",
  taille:            "",
  pb:                "",
  pc:                "",
  pn:                "",
  zscore:            "",
  resume:            "",
  date_prochain_rdv: "",
  motif_rdv:         "",
});

const INITIAL_DERNIERE_PAGE = { data: "" };

const TABS = [
  { id: "pages",        label: "Hospitalisations" },
  { id: "derniere_page", label: "Dernière page"   },
];

const NouvelleHospitalisation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id }   = useParams();
   const rawImages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.images || []);
    const IMAGES = rawImages.length > 0
    ? rawImages.map((img) => `${API_BASE}/${img.chemin_image}`)
    : [noImage];
  const { currentDossier, list } = useSelector((s) => s.dossiers);
  const dossier = currentDossier || list.find((d) => d.id === id) || null;
  const formulairesData  = useSelector((s) => s.formulaires.data);
  const savedPages       = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.pages        || [EMPTY_PAGE()]);
  const savedDernierePage= useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.derniere_page || INITIAL_DERNIERE_PAGE);
const [saving, setSaving] = useState(false);
  const [pages,        setPages]        = useState(savedPages);
  const [dernierePage, setDernierePage] = useState({ ...INITIAL_DERNIERE_PAGE, ...savedDernierePage });
  const [activeTab,    setActiveTab]    = useState("pages");
  const [imgIndex,     setImgIndex]     = useState(0);
    const [activePage, setActivePage] = useState(0);
    const pagesRef       = useRef(pages);
    const dernierePageRef = useRef(dernierePage);

    useEffect(() => { pagesRef.current        = pages;        }, [pages]);
    useEffect(() => { dernierePageRef.current = dernierePage; }, [dernierePage]);

    useEffect(() => {
        setImgIndex(activePage < IMAGES.length ? activePage : IMAGES.length - 1);
    }, [activePage]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    setPages(savedPages);
    setDernierePage({ ...INITIAL_DERNIERE_PAGE, ...savedDernierePage });
  }, [id]);

// APRÈS
const { goNext, goPrev, goTo, suivante, precedente, indexCourant, total } = useRubriqueNav(RUBRIQUE);
  const getPaginationItems = (total, current) => {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i);
  const items = [];
  items.push(0);
  if (current > 3) items.push("...");
  for (let i = Math.max(1, current - 1); i <= Math.min(total - 2, current + 1); i++) {
    items.push(i);
  }
  if (current < total - 4) items.push("...");
  items.push(total - 1);
  return items;
};

  // ── Handlers Pages ───────────────────────────────────────────────────────────
  const handleChangePage = (pageIndex, field, value) => {
    setPages((prev) => {
      const updated = [...prev];
      updated[pageIndex] = { ...updated[pageIndex], [field]: value };
      return updated;
    });
  };

    const handleAddPage = () => {
    setPages((prev) => [...prev, EMPTY_PAGE()]);
    setActivePage(pages.length);
    };

  const handleDeletePage = (pageIndex) => {
    setPages((prev) => prev.filter((_, i) => i !== pageIndex));
  };

    // ── Handlers Dernière page ───────────────────────────────────────────────────
    const handleChangeDernierePage = (field, value) => {
        setDernierePage((prev) => ({ ...prev, [field]: value }));
    };

    // ── Save / Cancel ────────────────────────────────────────────────────────────
    const handleSave = () => {
    dispatch(updateFormData(id, RUBRIQUE, "pages",         pagesRef.current));
    dispatch(updateFormData(id, RUBRIQUE, "derniere_page", dernierePageRef.current));
    };
    useEffect(() => {
        return () => {
        handleSave();
        };
    }, []);

    const handleSaveAll = async () => {
    setSaving(true);
    dispatch(updateFormData(id, RUBRIQUE, "pages",         pages));
    dispatch(updateFormData(id, RUBRIQUE, "derniere_page", dernierePage));
    try {
        const result = await dispatch(saveDossier());
        toast.success(result.message);
        navigate("/");
    } catch (err) {
        toast.error(err.response?.data?.message || "Erreur lors de la sauvegarde");
    }
    finally {
    setSaving(false);
  }
  };

  const handleCancel = () => {
    setPages(savedPages);
    setDernierePage({ ...INITIAL_DERNIERE_PAGE, ...savedDernierePage });
  };

  

  if (!dossier) {
    return (
      <div className="nh-no-dossier">
        <p>Aucun dossier sélectionné.</p>
        <button onClick={() => navigate("/")}>Retour à la liste</button>
      </div>
    );
  }

  return (
    <div className="nh-page">
         {saving && <SaveLoader />}
      {/* ── Header ── */}
      <header className="nh-header">
        <div className="nh-header-left">
          <button className="nh-back-btn" onClick={() => navigate("/")}>← Retour à la liste</button>
          <div>
            <h1 className="nh-title">Dossier {dossier.numero_dossier || dossier.id}</h1>
            <p className="nh-subtitle">Patient : {dossier.patient} &nbsp;|&nbsp; Service : {dossier.service}</p>
          </div>
        </div>
        <button className="nh-save-btn" onClick={handleSaveAll} disabled={saving}>Sauvegarder les modifications</button>
      </header>

      <div className="nh-body">
        {/* ── Colonne gauche : image ── */}
        <aside className="nh-image-panel">
          <div className="nh-image-header">
            <span className="nh-rubrique-label">Nouvelle Hospitalisation</span>
            <span className="nh-image-counter">Image {imgIndex + 1} / {IMAGES.length}</span>
          </div>
          <div className="nh-image-viewer">
            <img src={IMAGES[imgIndex]} alt={`Page ${imgIndex + 1}`} className="nh-image" />
          </div>
          <div className="nh-image-nav">
                <button className="nh-nav-btn" onClick={() => setImgIndex((i) => Math.max(0, i - 1))} disabled={imgIndex === 0}>‹</button>
                {getPaginationItems(IMAGES.length, imgIndex).map((item, i) =>
                    item === "..." ? (
                    <span key={i} className="nh-ellipsis">…</span>
                    ) : (
                    <button key={i}
                        className={`nh-nav-dot-btn ${imgIndex === item ? "nh-nav-dot-btn--active" : ""}`}
                        onClick={() => setImgIndex(item)}>
                        {item + 1}
                    </button>
                    )
                )}
                <button className="nh-nav-btn" onClick={() => setImgIndex((i) => Math.min(IMAGES.length - 1, i + 1))} disabled={imgIndex === IMAGES.length - 1}>›</button>
          </div>
        </aside>

        {/* ── Colonne droite : formulaire ── */}
        <main className="nh-form-panel">

          {/* ── Tabs ── */}
          <nav className="nh-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`nh-tab ${activeTab === tab.id ? "nh-tab--active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>

          {/* ── Contenu ── */}
          <div className="nh-tab-content">
            {activeTab === "pages" && (
              <TabPages
                pages={pages}
                activePage={activePage}
                setActivePage={setActivePage}
                onChangePage={handleChangePage}
                onAddPage={handleAddPage}
                onDeletePage={handleDeletePage}
                />
            )}
            {activeTab === "derniere_page" && (
              <TabDernierePage
                form={dernierePage}
                onChange={handleChangeDernierePage}
              />
            )}
          </div>

          {/* ── Actions ── */}
          {/* <div className="nh-form-actions">
            <button className="nh-btn-save" onClick={handleSave}>Enregistrer</button>
            <button className="nh-btn-cancel" onClick={handleCancel}>Annuler</button>
          </div> */}


<RubriqueNav goNext={goNext} goPrev={goPrev} goTo={goTo} suivante={suivante} precedente={precedente} indexCourant={indexCourant} total={total} />        </main>
      </div>
    </div>
  );
};

export default NouvelleHospitalisation;